import BaseView from './BaseView';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class EventView extends BaseView {
	constructor(container) {
		super(container);
		this.breakpoint = window.matchMedia('(max-width:992px)');
		this.header = this.container.querySelector('[data-event-header]');

		if (this.breakpoint.matches) {
			this.isDefault = true;
			this.setTrigger();
		}

		document.addEventListener('after-hook', () => {
			this.setTrigger();
		});
	}

	init() {
		//
	}

	setTrigger() {
		if (this.st) {
			return;
		}
		if (!this.header) {
			return;
		}
		this.st = new ScrollTrigger({
			trigger: this.header,
			end: 'bottom top',
			onToggle: () => {
				if (this.breakpoint.matches) {
					if (this.st.isActive) {
						this.goDefault();
					} else {
						this.goBlack();
					}
				} else {
					this.goDefault();
				}
			},
		});
	}

	goDefault() {
		if (this.isDefault) {
			return;
		}

		const color_m = this.container.dataset.colorM;
		const color_d = this.container.dataset.colorD;
		const background_m = this.container.dataset.backgroundM;
		const background_d = this.container.dataset.backgroundD;
		gsap.to(document.documentElement, {
			'--color-m': color_m,
			'--background-m': background_m,
			'--color-d': color_d,
			'--background-d': background_d,
			duration: 0.3,
			ease: 'none',
			overwrite: true,
			onComplete: () => {
				this.isDefault = true;
			},
		});
	}

	goBlack() {
		if (!this.isDefault) {
			return;
		}

		gsap.to(document.documentElement, {
			'--color-m': '0,0,0',
			duration: 0.3,
			ease: 'none',
			overwrite: true,
			onComplete: () => {
				this.isDefault = false;
			},
		});
	}

	destroy() {
		if (this.st) {
			this.st.kill();
		}
		super.destroy();
	}
}
